"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkClientConsoleLogger = exports.NetworkClientLogLevel = void 0;
var NetworkClientLogLevel;
(function (NetworkClientLogLevel) {
    NetworkClientLogLevel[NetworkClientLogLevel["DEBUG"] = 0] = "DEBUG";
    NetworkClientLogLevel[NetworkClientLogLevel["INFO"] = 1] = "INFO";
    NetworkClientLogLevel[NetworkClientLogLevel["WARN"] = 2] = "WARN";
    NetworkClientLogLevel[NetworkClientLogLevel["ERROR"] = 3] = "ERROR";
})(NetworkClientLogLevel = exports.NetworkClientLogLevel || (exports.NetworkClientLogLevel = {}));
class NetworkClientConsoleLogger {
    constructor(level = NetworkClientLogLevel.INFO) {
        this.info = console.log;
        this.debug = console.debug;
        this.error = console.error;
        this.warn = console.warn;
        const ignore = () => {
            // Ignore
        };
        switch (level) {
            default:
            case NetworkClientLogLevel.DEBUG:
                break;
            case NetworkClientLogLevel.INFO:
                this.debug = ignore;
                break;
            case NetworkClientLogLevel.WARN:
                this.debug = ignore;
                this.info = ignore;
                break;
            case NetworkClientLogLevel.ERROR:
                this.debug = ignore;
                this.info = ignore;
                this.warn = ignore;
                break;
        }
    }
}
exports.NetworkClientConsoleLogger = NetworkClientConsoleLogger;
